import React from 'react';
import { bbAnalytics } from '../helpers/analytics/setup/analytics.service.handler';

const Track = ({
  children, name, bbTrackLabelInfo, bbTrackCategoryInfo, bbTrackActionInfo, on = 'click',
}) => {
  function runTracking(provider) {
    const attributes = bbAnalytics.getAttributes({
      bbTrack: name,
      bbTrackActionInfo,
      bbTrackCategoryInfo,
      bbTrackLabelInfo,
    }, provider.providerElements);

    if (attributes) {
      // Dynamically add all the attributes.
      // Attribute `event` should be required then you can add any other
      // params as name, category, label etc.
      const {
        trackLabelInfo, trackCategoryInfo, trackActionInfo, ...event
      } = attributes;

      provider.providerInstance.eventTrack(
        event, trackLabelInfo, trackCategoryInfo, trackActionInfo,
      );
    } else {
      console.warn(`Unsupported bb-track ${name} name was used.`);
    }
  }


  function click() {
    bbAnalytics.providers.forEach((provider) => {
      runTracking(provider);
    });
  }

  if (on === 'show') {
    bbAnalytics.providers.forEach((provider) => {
      runTracking(provider);
    });

    return (
      <div>{ children }</div>
    );
  }

  return (
    <div onClick={click} role="presentation">
      { children }
    </div>

  );
};

export default Track;
